import { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext(null);

const THEMES = ["light", "dark", "purple", "pink"];
const ACCENTS = ["purple", "pink", "blue", "green", "orange", "red"];
const SIDEBAR_SIZES = ["compact", "normal", "large"];
const DENSITIES = ["comfortable", "compact"];
const LANGS = ["fr", "en", "es"];

const DEFAULTS = {
  theme: "light",
  accent: "purple",
  sidebarSize: "normal",
  density: "comfortable",
  lang: "fr",
};

const KEY = "cdo.preferences";

function loadPrefs() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : DEFAULTS;
  } catch { return DEFAULTS; }
}

export function ThemeProvider({ children }) {
  const [prefs, setPrefs] = useState(loadPrefs);

  useEffect(() => {
    const html = document.documentElement;
    THEMES.forEach(t => html.classList.remove(`theme-${t}`));
    html.classList.add(`theme-${prefs.theme}`);

    ACCENTS.forEach(a => html.classList.remove(`accent-${a}`));
    html.classList.add(`accent-${prefs.accent}`);

    html.setAttribute("data-density", prefs.density);
    html.lang = prefs.lang;
    localStorage.setItem(KEY, JSON.stringify(prefs));
  }, [prefs]);

  const set = useCallback((patch) => setPrefs(p => ({ ...p, ...patch })), []);

  return (
    <ThemeContext.Provider value={{ ...prefs, set, THEMES, ACCENTS, SIDEBAR_SIZES, DENSITIES, LANGS }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
